import React, { useState, useEffect, useCallback } from "react";
import { brokerLiveStatus } from "../lib/api";

const ago = (iso) => {
  if (!iso) return "no trades yet";
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  return m < 60 ? `${m}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`;
};

export const LiveTradingBadge = ({ userId }) => {
  const [s, setS] = useState(null);
  const load = useCallback(async () => { try { setS(await brokerLiveStatus(userId)); } catch (e) {} }, [userId]);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  if (!s) return null;
  const label = s.live ? "Trading live" : !s.engine_on ? "Preview · not trading" : !s.armed ? "Trading disarmed" : "Autopilot off";
  return (
    <span
      data-testid="live-trading-badge"
      title={`Last sweep ${ago(s.last_sweep_at)}`}
      className={`px-3 py-1.5 rounded-full text-xs font-extrabold flex items-center gap-1.5 border-2 border-[#1A1C19] ${s.live ? "bg-[#15803D] text-white" : "bg-[#DC2626] text-white"}`}
    >
      <span className={`w-2 h-2 rounded-full bg-white ${s.live ? "animate-pulse" : ""}`} />
      {label}
      <span className="font-semibold opacity-80" data-testid="live-trading-last-trade">· last trade {s.last_trade_symbol ? `${s.last_trade_symbol} ` : ""}{ago(s.last_trade_at)}</span>
    </span>
  );
};
